'use client';

import { usePathname } from 'next/navigation';
import { useActiveSection } from '@/hooks/useActiveSection';
import { LANDING_SECTION_IDS } from './modules/constants';
import DesktopNav from './modules/DesktopNav';
import MobileNav from './modules/MobileNav';

export default function LandingNav() {
  const pathname = usePathname();
  const sectionId = useActiveSection(LANDING_SECTION_IDS);
  const activeId = pathname === '/' ? sectionId : null;

  return (
    <header className='mb-16 text-base print:hidden'>
      <nav
        className='border-bui-color-silver bg-bui-color-white fixed! top-0 z-100 h-16.25 w-full border-b px-4 py-3
          font-medium'
      >
        <div className='max-[1345px]:hidden'>
          <DesktopNav activeId={activeId} />
        </div>
        <div className='hidden max-[1345px]:block'>
          <MobileNav activeId={activeId} />
        </div>
      </nav>
    </header>
  );
}
